// VideoHero.css.ts
import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const styles = tv({
  slots: {
    base: [
      // 60px top/bottom and 20px left/right padding on screens < 992px;
      // padding removed at lg and above
      'py-[60px] px-[20px] lg:py-0 lg:px-0',
      'w-full bg-[#131313]',
      'flex flex-col lg:relative lg:h-[100dvh] lg:overflow-hidden',
    ],
    videoWrapper: [
      // Add 30px top margin on mobile, reset at lg
      'w-full aspect-video order-2 lg:order-1 z-0 mt-[30px] lg:mt-0',
      'lg:absolute lg:inset-0 lg:w-full lg:h-full',
    ],
    video: 'w-full h-full object-cover',
    overlay: [
      'hidden lg:block absolute inset-0 bg-black/40 z-0',
    ],
    content: [
      // Removed mobile padding; now only applies at md breakpoint and up
      'w-full md:px-4 flex flex-col items-start lg:items-center justify-center gap-4 order-1 lg:order-2 z-00',
      'lg:absolute lg:inset-0',
    ],
    title: [
      'font-bold w-full leading-[1.1] text-white font-condensed',
      'text-left lg:text-center',
      'text-[42px] md:text-[40px] lg:text-[80px]',
    ],
    titlePink: '!text-[#FF77A8]',
    description: [
      'text-left lg:text-center max-w-[120rem] font-regular text-white',
      'text-[22px] md:text-[24px] lg:text-[28px]',
    ],
  },
})

export type VideoHeroVariants = VariantProps<typeof styles>
